<template>
  <div class="sus-window" :style="{ zIndex: inviteShow ? 999 : 300 }">
    <div class="col_btn">
      <div v-if="activityBtnShow" class="link-but prize-link" @click="linkActivity">
        <img :src="getByRefurbishName('activity').refurbishJson.icon" />
      </div>
    </div>
    <div class="col_btn">
      <div v-if="signBtnShow" class="link-but prize-link" @click="signIn">
        <img :src="signLink" />
      </div>
    </div>
    <!-- 抽奖 -->
    <div class="col_btn prize_post">
      <div v-if="lotteryBtnShow" class="link-but prize-link " @click="linkToLottery">
        <div v-if="enableCustomLottery || isJdCustom">
          <img :src="prizeLink" :class="prize_imgs" />
          <span class="badges" v-if="times">{{ times }}</span>
        </div>
        <div v-else>
          <img :src="prizeLink" />
        </div>
      </div>
    </div>
    <div class="col_btn">
      <div v-if="invitationBtnShow" class="link-but invite-link" @click="showInvite">
        <img :src="inviteLink" />
      </div>
    </div>
    <template v-if="praiseBtnShow">
      <ft-icon v-if="isJa" icon="" :class="likeActive ? 'active' : ''">
        <img src="@/assets/images/ja/praise3.png" alt="" srcset="" />
        <give-like class="give-like" ref="piao" @praise="addPraise" />
        <span v-if="praiseCount && showCount" class="badge">{{ praiseCount }}</span>
      </ft-icon>
      <ft-icon v-else icon="icon-dianzan1" class="give-like-icon" :class="likeActive ? 'active' : ''">
        <give-like class="give-like" ref="piao" @praise="addPraise" />
        <span v-if="praiseCount && showCount" class="badge">{{ praiseCount }}</span>
      </ft-icon>
    </template>
    <ft-icon class="share-icon" v-if="shareBtnShow" @click="toShare" icon="icon-fenxiang1" />
    <Invite class="invite" v-if="inviteShow" @close="inviteShow = false" :data="inviteData" />
    <!-- 可定制ui的抽奖， 静安 -->
    <van-action-sheet v-if="isJa" style="margin-bottom: 0px" v-model="lotterySheetShow" title="" class="jinganbanner">
      <div class="close_icon" @click="lotterySheetShow = false"></div>
      <div
        v-if="currentLottery"
        :class="['tabs-panels', lotteryInfo.winListFlg == '0' ? '' : 'tabs-img']"
        :style="{ backgroundImage: 'url(' + bgImg + ')' }"
      >
        <van-tabs v-model="lotteryTabActive" @change="tabChange">
          <van-tab name="info" class="lottery-info-tabs" title="参与抽奖" :title-style="{ backgroundImage: 'url(' + tabBtnBgImg + ')' }">
            <div class="wap" :style="{ background: descBgColor }">
              <div class="title">{{ lotteryInfo.lotteryTitle }}</div>
              <pre class="desc">{{ lotteryInfo.lotteryDescription }}</pre>
            </div>
            <div class="little_title row">{{ currentLottery.roundName }}</div>
            <div class="row">
              <div class="label">抽奖时间：</div>
              <div class="value">{{ currentLottery.lotteryTime }}</div>
            </div>
            <div class="row_border">
              <div class="label">抽奖条件：</div>
              <div class="row_wap" v-if="lotteryInfo.lotteryCond == '1'">
                <div>已登陆用户</div>
                <div class="row_correct">
                  已达成
                  <span>
                    <img src="~@/assets/images/lotteryCond_icon.png" />
                  </span>
                </div>
              </div>
              <div v-if="lotteryInfo.lotteryCond == '2'" class="row_wap">
                <div>留言并通过审核</div>
                <div class="row_correct" v-if="conditionFlg">
                  已达成
                  <span>
                    <img src="~@/assets/images/lotteryCond_icon.png" />
                  </span>
                </div>
                <div class="row_correct" v-else>
                  未达成
                  <span class="row_error">x</span>
                </div>
              </div>
              <div v-if="lotteryInfo.lotteryCond == '3'" class="row_wap">
                <div>发送快捷聊天语</div>
                <div class="row_correct" v-if="conditionFlg">
                  已达成
                  <span>
                    <img src="~@/assets/images/lotteryCond_icon.png" />
                  </span>
                </div>
                <div class="row_correct" v-else>
                  未达成
                  <span class="row_error">x</span>
                </div>
              </div>
            </div>
            <div class="button">
              <van-button :class="['btn', currentLottery.roundStatus == '1' ? 'btns' : 'black']" @click="joinLottery" type="info">{{
                currentLottery.roundStatus == '1' ? '去发表评论' : '已抽奖'
              }}</van-button>
            </div>
          </van-tab>
          <div :style="{ background: 'url(' + tabBtnBgImg + ')' }"></div>
          <van-tab
            class="lottery-result-tab"
            v-if="lotteryInfo.winListFlg == '0'"
            title="中奖名单"
            name="result"
            :title-style="{ backgroundImage: 'url(' + tabBtnBgImg + ')' }"
          >
            <van-tabs
              class="lottery-result-tab-tabs"
              :class="[lotteryInfo && lotteryInfo.rounds.length > 1 ? '' : 'lottery-result-tab-tabs-hidden']"
              v-model="roundTabActive"
              scrollspy
            >
              <van-tab v-for="(round, index) in lotteryInfo.rounds" :name="round.id" :title="'第' + numMap[index] + '批'" :key="round.id">
                <div></div>
              </van-tab>
            </van-tabs>
            <div class="lottery-result-tab-list" :class="[lotteryInfo && lotteryInfo.rounds.length > 1 ? '' : 'no-tabs']">
              <div class="result-list">
                <div v-for="(item, i) in activeResultLottery.drawlResults" :key="i" class="col">
                  <div>{{ item.drawlNickname }}</div>
                  <div class="phone">{{ item.drawlMobile }}</div>
                </div>
                <div class="round-b-flg" style="width: 100px;height:1px"></div>
              </div>
              <p :style="{ opacity: ifshow ? '1' : '0' }" class="waps_bottom">下拉更多</p>
              <div v-if="activeResultLottery.roundStatus === '2'" class="button">
                <!-- 未中奖 -->
                <van-button v-if="!activeResultLottery.winRecord" :class="['btn', 'black']" type="info">很遗憾，您未中奖</van-button>
                <!-- 未填写领奖信息 -->
                <van-button
                  v-else-if="activeResultLottery.winRecord && !activeResultLottery.winRecord.receiveName"
                  :class="['btn', 'btns']"
                  @click="jaShowLotteryForm(activeResultLottery)"
                  type="info"
                  >立即领奖</van-button
                >
                <!-- 填写领奖信息但没填写地址 -->
                <van-button
                  v-else-if="
                    activeResultLottery.winRecord && activeResultLottery.winRecord.receiveName && !activeResultLottery.winRecord.receiveAddress
                  "
                  :class="['btn', 'btns']"
                  @click="jaShowLotteryForm(activeResultLottery)"
                  type="info"
                  >修改领奖地址</van-button
                >
                <!-- 已填写完成 -->
                <van-button v-else :class="['btn', 'black']" type="info">您已填写领奖信息</van-button>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-action-sheet>
    <!--可定制ui的抽奖， 嘉定（非快捷聊天抽奖） -->
    <van-action-sheet v-else-if="enableJdCustomLottery" style="margin-bottom: 0px" v-model="lotterySheetShow" title="" class="jdbanner">
      <div class="close_icon" @click="lotterySheetShow = false"></div>
      <div
        v-if="currentLottery"
        :class="['tabs-panels', lotteryInfo.winListFlg == '0' ? '' : 'tabs-img']"
        :style="{ backgroundImage: 'url(' + bgImg + ')' }"
      >
        <van-tabs @change="tabChange">
          <van-tab class="lottery-info-tabs" title="参与抽奖" :title-style="{ backgroundImage: 'url(' + tabBtnBgImg + ')' }">
            <div class="wap" :style="{ background: descBgColor }">
              <div class="title">{{ lotteryInfo.lotteryTitle }}</div>
              <pre class="desc">{{ lotteryInfo.lotteryDescription }}</pre>
            </div>
            <div class="little_title row">{{ currentLottery.roundName }}</div>
            <div class="row">
              <div class="label">抽奖时间：</div>
              <div class="value">{{ currentLottery.lotteryTime }}</div>
            </div>
            <div class="row_border">
              <div class="label">抽奖条件：</div>
              <div class="row_wap" v-if="lotteryInfo.lotteryCond == '1'">
                <div>已登陆用户</div>
                <div class="row_correct">
                  已达成
                  <span>
                    <img src="~@/assets/images/lotteryCond_icon.png" />
                  </span>
                </div>
              </div>
              <div v-if="lotteryInfo.lotteryCond == '2'" class="row_wap">
                <div>留言并通过审核</div>
                <div class="row_correct" v-if="conditionFlg">
                  已达成
                  <span>
                    <img src="~@/assets/images/lotteryCond_icon.png" />
                  </span>
                </div>
                <div class="row_correct" v-else>
                  未达成
                  <span class="row_error">x</span>
                </div>
              </div>
              <div v-if="lotteryInfo.lotteryCond == '3'" class="row_wap">
                <div>发送快捷聊天语</div>
                <div class="row_correct" v-if="conditionFlg">
                  已达成
                  <span>
                    <img src="~@/assets/images/lotteryCond_icon.png" />
                  </span>
                </div>
                <div class="row_correct" v-else>
                  未达成
                  <span class="row_error">x</span>
                </div>
              </div>
            </div>
            <div class="button">
              <van-button :class="['btn', currentLottery.roundStatus == '1' ? 'btns' : 'black']" @click="joinLottery" type="info">{{
                currentLottery.roundStatus == '1' ? '去发表评论' : '已抽奖'
              }}</van-button>
            </div>
          </van-tab>
          <div :style="{ background: 'url(' + tabBtnBgImg + ')' }"></div>
          <van-tab
            class="lottery-result-tab"
            v-if="lotteryInfo.winListFlg == '0'"
            title="中奖名单"
            :title-style="{ backgroundImage: 'url(' + tabBtnBgImg + ')' }"
          >
            <div :class="['waps', ifshow ? '' : 'wapse']" ref="resListRef">
              <div v-for="(item, i) in currentLottery.drawlResults" :key="i" class="col">
                <div>{{ item.drawlNickname }}</div>
                <div class="phone">{{ item.drawlMobile.slice(0, 3) + '****' + item.drawlMobile.slice(8) }}</div>
              </div>
            </div>
            <p v-show="ifshow" class="waps_bottom">下拉更多</p>
          </van-tab>
        </van-tabs>
      </div>
    </van-action-sheet>
    <!-- 嘉定定制快捷抽奖 -->
    <van-action-sheet v-else-if="isJdCustom" style="margin-bottom: 0px" v-model="lotterySheetShow" title="" class="jd-custom-3">
      <div v-if="currentLottery" class="jd-custom-3_wrap">
        <!-- 已开奖 -->
        <template v-if="currentLottery.roundStatus === '2'">
          <div class="jd-custom-3_top-title">
            <img class="top-title_left" src="@/assets/images/jd-lottery/icon-line-left.png" alt="" />
            <div class="top-title_text">中奖名单</div>
            <img class="top-title_right" src="@/assets/images/jd-lottery/icon-line-right.png" alt="" />
          </div>
          <div class="jd-custom-3_luck-list">
            <template v-for="(item, i) in currentLottery.drawlResults">
              <div :key="i" class="luck-list_item">
                <div class="luck-list_item-name">{{ item.drawlNickname }}</div>
                <div class="luck-list_item-phone">{{ item.drawlMobile.slice(0, 3) + '****' + item.drawlMobile.slice(8) }}</div>
              </div>
              <van-divider :key="i"></van-divider>
            </template>
          </div>
        </template>
        <!-- 待参与/开奖 -->
        <template v-else-if="currentLottery.roundStatus === '1'">
          <div class="jd-custom-3_top-time">{{ times ? `${times}后开奖` : '等待主播开奖' }}</div>
          <div class="jd-custom-3_top-title">
            <img class="top-title_left" src="@/assets/images/jd-lottery/icon-line-left.png" alt="" />
            <div class="top-title_text">{{ lotteryInfo.lotteryTitle }}</div>
            <img class="top-title_right" src="@/assets/images/jd-lottery/icon-line-right.png" alt="" />
          </div>
          <div class="jd-custom-3_prize">
            <img v-if="lotteryInfo.attrs && lotteryInfo.attrs.prizeImg" :src="lotteryInfo.attrs.prizeImg" alt="" />
          </div>
          <div class="jd-custom-3_token" v-if="commonWords[0]">评论口令：{{ commonWords[0].commonWord }}</div>
          <div class="jd-custom-3_btn" v-if="!conditionFlg" @click="joinLottery">一键评论并参与</div>
          <div class="jd-custom-3_btn disabled" v-else>等待主播开奖</div>
          <div class="jd-custom-3_tip">抽奖发起及内容由主播自行决定并承担责任</div>
        </template>
        <img class="jd-custom-3_close" @click="lotterySheetShow = false" src="@/assets/images/jd-lottery/icon-close.png" alt="" />
      </div>
    </van-action-sheet>
    <!-- 通用抽奖 -->
    <van-action-sheet v-else style="margin-bottom: 0px" v-model="lotterySheetShow" title="">
      <div v-if="currentLottery" class="tabs-panels">
        <van-tabs @change="tabChange">
          <van-tab class="lottery-info-tab" title="参与抽奖">
            <div class="title">{{ lotteryInfo.lotteryTitle }}</div>
            <pre class="desc">{{ lotteryInfo.lotteryDescription }}</pre>
            <div class="row">{{ currentLottery.roundName }}</div>
            <div class="row">
              <div class="label">抽奖时间：</div>
              <div class="value">{{ currentLottery.lotteryTime }}</div>
            </div>
            <div class="row">
              <div class="label">抽奖条件：</div>
              <div class="value">{{ lotteryInfo.lotteryCond == '1' ? '已登陆用户' : lotteryInfo.lotteryCond == '2' ? '留言并通过审核' : '' }}</div>
            </div>
            <div class="button">
              <van-button class="btn" @click="joinLottery" type="info">{{ currentLottery.roundStatus == '1' ? '立即参与' : '已抽奖' }}</van-button>
            </div>
          </van-tab>
          <van-tab class="lottery-result-tab" v-if="lotteryInfo.winListFlg == '0'" title="中奖名单">
            <div>
              <div v-for="(item, i) in currentLottery.drawlResults" :key="i" class="lottery_col">
                <div>{{ item.drawlNickname }}</div>
                <div class="phone">{{ item.drawlMobile.slice(0, 3) + '****' + item.drawlMobile.slice(8) }}</div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-action-sheet>

    <!-- ja 提示中奖 -->
    <van-popup style="background:transparent" v-model="jaLotteryWinTipShow">
      <img @click="jaShowLotteryForm()" src="@/assets/images/ja-lottery/win.png" alt="" srcset="" />
      <div style="display:flex;justify-content: center;">
        <img @click="closeWinTip" style="width: 29px;height:29px;margin-top:49px" src="@/assets/images/ja-lottery/icon-close.png" alt="" srcset="" />
      </div>
    </van-popup>

    <!-- 领奖信息表单 -->
    <van-popup
      class="ja-win-form-popup"
      :close-on-click-overlay="false"
      style="border-radius: 15px;width: 310px;min-height: 400px;"
      v-model="jaLotteryFormShow"
    >
      <div class="win-form-title">
        信息录入
        <van-icon @click="jaLotteryFormShow = false" class="close-icon" name="cross" />
      </div>
      <div class="win-form-sub-title">请中奖用户及时提交您的联系信息，以便发放奖品。</div>
      <div style="padding: 0 12px">
        <!-- 输入任意文本 -->
        <van-field required v-model="winRecordForm.receiveName" label="姓名" />
        <van-field v-model="winRecordForm.drawlMobile" readonly label="手机" />
        <van-field v-model="winRecordForm.receiveAddress" label="地址" />
        <van-field v-model="winRecordForm.receiveRemarks" type="textarea" rows="3" autosize label="备注" />
        <van-field style="height:0;padding:0;" readonly></van-field>
        <van-button @click="submitWinRecord" class="submit-btn" :loading="submitWinFormLoading" type="info">提交</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { openAppAndLoginInterceptor, needOpenApp, isRmtEnv, getRoomShareViewAuth, isLogin } from '@/core/index';
import moment from 'moment';
import store from '@/core/config.store';
const isJa = () => $$.module.data.room.siteId === '310106';
export default {
  name: 'Suswindow',
  data() {
    return {
      room: $$.module.data.room,
      likeActive: false,
      isRmtEnv,
      api: $$.module.interview.$api,
      inviteShow: false,
      inviteLink: require('@/assets/images/sus-window-img.png'),
      prizeLink: isJa() ? require('@/assets/images/ja-lottery/icon-btn.png') : require('@/assets/images/prize-icon.png'),
      signLink: require('@/assets/images/sign.png'),
      inviteData: {},
      praiseCount: 0,
      signStatus: $$.module.interview.data.status.sign.no,
      lotteryInfo: {
        rounds: null
      },
      lotteryTabActive: 'info',
      lotteryShow: false,
      lotterySheetShow: false,
      currentLottery: null,
      times: '', // 倒计时
      siteId: $$.module.data.room.siteId,
      // siteId: 310106,
      count: 15, // 定时器
      counts: 15, // 定时器
      prize_imgs: '', // 样式
      descBgColor: '', // 抽奖区域颜色
      bgImg: '', //背景
      tabBtnBgImg: '', //tab背景
      conditionFlg: false, // 判断用户是否已经达成抽奖条件
      ifshow: false, // 判断下拉更多
      commonWords: [], // 快捷聊天语列表
      lastTimesTimer: null, // 倒计时文字定时器
      roundLotteryAnimatedCache: {}, // 已经抽奖图标动画， 每轮只播放一次
      lotteryWinRecords: [], // 用户中奖记录

      jaLotteryWinTipShow: false, // 静安，中奖提示
      jaLotteryFormShow: false, // 静安，填写中奖信息表单
      roundTabActive: undefined,
      numMap: {
        0: '一',
        1: '二',
        2: '三',
        3: '四',
        4: '五',
        5: '六',
        6: '七',
        7: '八',
        8: '九',
        9: '十'
      },
      winRecordForm: {},
      submitWinFormLoading: false,
      isFirstPraise: true,
      isCallbackedPraise: false,
      lastPraiseTime: 0
    };
  },
  mounted() {
    this.praiseCount = this.room.roomCount?.praiseCount;
    this.likeActive = this.like;
    this.getInviteCard();
    this.getRoomSignStatus();
    this.getLotteryInfo();
    this.roomSignTimer = setInterval(() => {
      this.getRoomSignStatus();
    }, 60000);
    window.addEventListener('scroll', this.scrollToTop, true);
    this.getCommonWord();
  },
  computed: {
    isNeedOpenApp() {
      return needOpenApp();
    },
    showIcon() {
      return isRmtEnv() || this.isNeedOpenApp || getRoomShareViewAuth().enableLogin;
    },
    enableJdCustomLottery() {
      return this.isJd && (this.lotteryInfo.lotteryCond === '1' || this.lotteryInfo.lotteryCond === '2');
    },
    enableCustomLottery() {
      return this.isJa || this.enableJdCustomLottery;
    },
    isJa() {
      return this.siteId == 310106;
    },
    isJd() {
      return this.siteId == 310114;
    },
    // 嘉定定制快捷抽奖
    isJdCustom() {
      return this.isJd && this.isCommonWordLottery;
    },
    // 是快捷聊天语抽奖
    isCommonWordLottery() {
      return this.lotteryInfo?.lotteryCond == '3';
    },
    // 人气值是否开启
    showCount() {
      return this.getByRefurbishName('peopleNumber').refurbishFlg === '0';
    },
    activeResultLottery() {
      return this.lotteryInfo.rounds?.find((v) => v.id === this.roundTabActive);
    },
    // 静安 自定义活动按钮
    activityBtnShow() {
      return (
        this.isJa &&
        this.showIconByName('activity') &&
        this.getByRefurbishName('activity').refurbishJson.icon &&
        this.getByRefurbishName('activity').refurbishJson.link
      );
    },
    // 签到按钮
    signBtnShow() {
      return this.showSignIcon();
    },
    // 抽奖按钮
    lotteryBtnShow() {
      return this.lotteryShow;
    },
    // 邀请卡按钮
    invitationBtnShow() {
      return this.showIconByName('invitation');
    },
    // 点赞按钮
    praiseBtnShow() {
      return this.showIconByName('like');
    },
    // 分享按钮
    shareBtnShow() {
      return !this.isJa && this.getByRefurbishName('share').refurbishFlg === '0' && isRmtEnv();
    },
    // 是否有按钮显示
    hasBtn() {
      return Boolean(
        this.activityBtnShow || this.signBtnShow || this.lotteryBtnShow || this.invitationBtnShow || this.praiseBtnShow || this.shareBtnShow
      );
    }
  },
  watch: {
    lotterySheetShow: {
      handler() {
        if (this.isCommonWordLottery) {
          this.getCommonWord();
        }
      },
      immediate: true
    },
    hasBtn: {
      handler(val) {
        console.log('watch hasBtn', val);
        store.commit('SET_SUSWINDOW_HAS_BTN', val);
      },
      immediate: true
    }
  },
  methods: {
    getLotteryBtnDefault(icon) {
      if (icon) return icon;
      return isJa() ? require('@/assets/images/ja-lottery/icon-btn.png') : require('@/assets/images/prize-icon.png');
    },
    closeWinTip() {
      this.jaLotteryWinTipShow = false;
      console.log('xxx');
    },
    jaShowLotteryWinTip() {
      console.log('lotteryInfo', this.lotteryInfo);
      if (this.isJa && this.lotterySheetShow) {
        // - 用户未中奖，或已填写领奖信息，则不提示；
        const round = this.lotteryInfo.rounds.find((v) => v.winRecord && !v.winRecord.receiveName);
        console.log('win round ==>', round);
        if (round) {
          this.winRecordForm = { ...round.winRecord };
          this.jaLotteryWinTipShow = true;
          this.lotteryTabActive = 'result';
          this.roundTabActive = round.id;
        }
      }
    },
    // 显示填写中奖信息表单
    jaShowLotteryForm(round) {
      if (round) {
        this.winRecordForm = { ...round.winRecord };
      }
      this.jaLotteryFormShow = true;
      this.jaLotteryWinTipShow = false;
    },
    submitWinRecord() {
      if (!this.winRecordForm.receiveName || !this.winRecordForm.receiveName.trim()) {
        this.$toast('姓名不能为空');
        return;
      }
      this.submitWinFormLoading = true;
      console.log('win record ==>', this.winRecordForm);
      this.api.saveLotteryResult({
        data: this.winRecordForm,
        success: () => {
          this.getLotteryInfo();
          this.$toast.success('提交成功');
          this.submitWinFormLoading = false;
          this.jaLotteryFormShow = false;
        },
        fail: () => {
          this.submitWinFormLoading = false;
        }
      });
    },
    // ==== 快捷聊天语 =====
    getCommonWord() {
      this.api.commonWords({
        data: {
          pageNo: 1,
          pageSize: 100,
          roomId: $$.module.data.room.roomId
        },
        success: (res) => {
          res?.records?.length && (this.commonWords = res.records);
        }
      });
    },

    tabChange() {
      this.getLotteryInfo();
    },
    /**
     * 处理抽奖
     *  - 倒计时显示
     *  - 已经抽奖图标动画显示
     */
    lotteryIconAndTimeHandle() {
      this.checkPrize();
      this.lastcounts();
      if (this.lastTimesTimer) {
        clearInterval(this.lastTimesTimer);
        this.lastTimesTimer = null;
      }
      // 待抽奖
      if (this.currentLottery?.roundStatus === '1') {
        this.lastTimesTimer = setInterval(() => {
          this.last_times();
        }, 1000);
        // 已抽奖
      } else if (this.currentLottery?.roundStatus === '2' && !this.roundLotteryAnimatedCache[this.currentLottery.id]) {
        // 清除倒计时文字
        this.times = '';
        this.roundLotteryAnimatedCache[this.currentLottery.id] = true;
        // 播放抽奖图标动画
        this.sendCode((this.prizeLink = this.getLotteryBtnDefault(this.lotteryInfo.attrs?.icon)));
      }
    },
    getLotteryWinRecord(cb) {
      this.api.getUserLotteryWinRecord({
        data: { roomId: $$.module.data.room.roomId },
        success: (res) => {
          this.lotteryWinRecords = res || [];
          cb?.(this.lotteryWinRecords);
        }
      });
    },
    getLotteryInfo(cb) {
      clearInterval(this.timers);
      this.timers = null;
      this.counts = 15;
      this.api.getLotteryInfo({
        data: { roomId: $$.module.data.room.roomId },
        success: (res) => {
          if (res && res.lotteryFlg === '0') {
            this.lotteryShow = this.showIcon;
            this.lotteryInfo = res;
            isLogin().then(() => {
              this.getLotteryWinRecord((results) => {
                console.log('====> results', results);
                if (results.length) {
                  // 把中奖记录匹配到轮次
                  res.rounds?.forEach((item) => {
                    const roundId = item.id;
                    const ret = results.find((v) => v.roundId === roundId);
                    if (ret) {
                      item.winRecord = ret;
                    }
                  });
                }
                console.log('===> getLotteryInfo', res);
                this.lotteryInfo = res;
                if (this.lotteryInfo?.rounds?.length) {
                  const activeLottery = this.lotteryInfo.rounds.find((e) => e.roundStatus === '1');
                  this.currentLottery = activeLottery || this.lotteryInfo.rounds[this.lotteryInfo.rounds.length - 1];
                  if (!this.roundTabActive) {
                    this.roundTabActive = this.lotteryInfo.rounds[0].id;
                    console.log('===> roundTabActive', this.roundTabActive);
                  }
                }
                if (this.enableCustomLottery) {
                  this.prizeLink = this.getLotteryBtnDefault(res.attrs?.icon);
                  this.bgImg = res.attrs?.bgImg ? res.attrs?.bgImg : require('@/assets/images/jinganbanner.png');
                  this.tabBtnBgImg = res.attrs?.tabBtnBgImg ? res.attrs?.tabBtnBgImg : require('@/assets/images/tab_big.png');
                  this.descBgColor = res.attrs?.descBgColor ? res.attrs?.descBgColor : '#3B94DC';
                  const num = this.isJa ? 6 : 7;
                  if (this.lotteryInfo?.rounds?.length) {
                    if (this.currentLottery?.drawlResults.length > num) {
                      this.ifshow = true;
                    } else {
                      this.ifshow = false;
                    }
                  }
                  this.lotteryIconAndTimeHandle();
                } else if (this.isJdCustom) {
                  this.prizeLink = this.getLotteryBtnDefault(res.attrs?.icon);
                  this.lotteryIconAndTimeHandle();
                  this.getCommonWord();
                } else {
                  this.prizeLink = this.getLotteryBtnDefault(res.attrs?.icon);
                }
                cb?.();
              });
            });
          } else {
            this.lotteryInfo = { rounds: null };
            cb?.();
          }
        }
      });
    },
    checkPrize() {
      isLogin()
        .then(() => {
          this.api.checkPrize({
            data: { roomId: $$.module.data.room.roomId },
            success: (res) => {
              this.conditionFlg = res.data.conditionFlg;
            }
          });
        })
        .catch(() => {
          console.log('未登录');
        });
    },
    showSignIcon() {
      return this.signStatus !== 'no' && this.showIcon;
    },
    showIconByName(name) {
      return this.getByRefurbishName(name) && this.getByRefurbishName(name).refurbishFlg === '0' && this.showIcon;
    },
    getRoomSignStatus() {
      this.api.getRoomSignStatus({
        data: {
          roomId: $$.module.data.room.roomId,
          roomType: '1'
        },
        success: (res) => {
          this.signStatus = res?.signFlg || $$.module.interview.data.status.sign.no;
        }
      });
    },

    signIn() {
      openAppAndLoginInterceptor(() => {
        this.api.addSign({
          data: {
            roomId: $$.module.data.room.roomId,
            roomType: '1'
          },
          success: () => {
            this.$toast('签到成功');
          },
          exception: () => {
            this.$toast('签到失败！');
          }
        });
      });
    },

    // 活动链接跳转
    async linkActivity() {
      openAppAndLoginInterceptor(() => {
        let link = this.getByRefurbishName('activity').refurbishJson.link || '';
        const pIndex = link.indexOf('?');
        if (pIndex === -1) {
          link += '?token=' + $$.token.get();
        } else {
          link += '&token=' + $$.token.get();
        }
        window.location.href = link;
      });
    },
    // 抽奖
    async linkToLottery() {
      openAppAndLoginInterceptor(() => {
        this.getLotteryInfo(() => {
          // 后台抽
          if (this.lotteryInfo.lotteryType === '1') {
            if (this.lotteryInfo.rounds?.length) {
              this.lotterySheetShow = true;
              this.jaShowLotteryWinTip();
            } else {
              this.$toast('暂无抽奖');
            }
          }
          // 外链
          else if (this.lotteryInfo.lotteryType === '2') {
            window.location.href = this.lotteryInfo.outLink;
          }
        });
      });
    },
    // 参与抽奖
    joinLottery() {
      if (this.currentLottery.roundStatus == '2') {
        this.$toast('本期抽奖已结束');
        return;
      }
      if (this.lotteryInfo.lotteryCond === '1') {
        openAppAndLoginInterceptor(() => {
          this.$toast.success('已参与抽奖');
          this.lotterySheetShow = false;
        });
      } else if (this.lotteryInfo.lotteryCond === '2') {
        openAppAndLoginInterceptor(() => {
          this.$toast('去留言既可参与抽奖～');
          this.lotterySheetShow = false;
        });
      } else if (this.lotteryInfo.lotteryCond === '3') {
        openAppAndLoginInterceptor(() => {
          if (this.commonWords?.length) {
            this.api.sendMemberCommonWordMsg({
              data: {
                roomId: $$.module.data.room.roomId,
                commonWordId: this.commonWords[0].id
              },
              success: () => {
                this.$toast('已参与抽奖');
                this.lotterySheetShow = false;
              },
              execption: () => {
                this.$toast.fail('发送失败');
              }
            });
          }
        });
      }
    },
    // 邀请卡
    async showInvite() {
      openAppAndLoginInterceptor(() => {
        this.inviteShow = true;
      });
    },
    // 分享
    toShare() {
      openAppAndLoginInterceptor(
        () => {
          if (this.isRmtEnv()) {
            rmt.openMoreBox({
              wechat: 'enable',
              wechatMoment: 'enable',
              qq: 'enable',
              qqZone: 'enable',
              weibo: 'enable',
              copyLink: 'enable',
              theme: 'dismiss', //字体/配色
              report: 'enable'
            });
            return;
          }
        },
        {
          requireLogin: false
        }
      );
    },
    // 点赞
    addPraise() {
      const time = new Date().getTime();
      if (!this.isFirstPraise && !this.isCallbackedPraise) {
        if (time - this.lastPraiseTime < 1000) {
          this.lastPraiseTime = time;
          return;
        }
      }
      this.lastPraiseTime = time;
      this.isFirstPraise = false;
      openAppAndLoginInterceptor(() => {
        this.isCallbackedPraise = true;
        this.api.addPraise({
          data: {
            roomId: $$.module.data.room.roomId,
            roomType: '1'
          },
          success: () => {
            this.likeActive = true;
            this.praiseCount++;
          }
        });
      });
    },

    linkTo(val) {
      val && (window.location.href = val);
    },
    getInviteCard() {
      this.api.inviteDe({
        data: {
          roomId: $$.module.data.room.roomId
        },
        success: (res) => {
          this.inviteData = res;
        }
      });
    },
    getByRefurbishName(name) {
      return this.room.roomRefurbish.find((data) => data.refurbishName === name);
    },
    repairZero(v) {
      if (v < 10) {
        return `0${v}`;
      }
      return v;
    },
    // 抽奖倒计时
    last_times() {
      const activeLottery = this.lotteryInfo.rounds.find((e) => e.roundStatus === '1');
      const timelist = activeLottery || this.lotteryInfo.rounds[this.lotteryInfo.rounds.length - 1];
      let date1 = new Date(timelist.lotteryTime.replace(/-/g, '/')).getTime();
      let date2 = moment().toDate();
      let date3 = date1 - date2;
      let days = Math.floor(date3 / (24 * 3600 * 1000));
      let leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000));
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);
      if (date3 > 0 && activeLottery) {
        if (date3 < 1600) {
          clearInterval(this.timers);
        }
        if (days > 0) {
          this.times = days + ':' + this.repairZero(hours) + ':' + this.repairZero(minutes) + ':' + this.repairZero(seconds);
        } else {
          if (hours > 0) {
            this.times = this.repairZero(hours) + ':' + this.repairZero(minutes) + ':' + this.repairZero(seconds);
          } else {
            if (minutes > 0) {
              this.times = this.repairZero(minutes) + ':' + this.repairZero(seconds);
            } else {
              if (seconds == 1) {
                this.times = '00:' + this.repairZero(1);
                clearInterval(this.timer);
                this.timer = null;
                this.count = 15;
                this.sendCode(
                  (this.prizeLink = this.lotteryInfo.attrs?.icon ? this.lotteryInfo.attrs?.icon : require('@/assets/images/prize-icon.png'))
                );
              } else {
                this.times = '00:' + this.repairZero(seconds);
              }
            }
          }
        }
      } else {
        this.times = '';
      }
    },
    // 15s刷新
    lastcounts() {
      if (this.timers) return;
      this.timers = setInterval(() => {
        // console.log(this.counts, 'lastcounts');
        if (this.counts === 0) {
          clearInterval(this.timers);
          this.getLotteryInfo();
          this.timers = null;
          this.counts = 15;
        } else {
          this.counts--;
        }
      }, 1000);
    },
    // 图标倒计时
    sendCode(val) {
      if (this.timer) return;
      this.timer = setInterval(() => {
        this.prize_imgs = 'prize_img';
        this.prizeLink = require('@/assets/images/prize-icon2.gif');
        // 创建定时器
        if (this.count === 0) {
          this.prize_imgs = '';
          this.prizeLink = val;
          clearInterval(this.timer);
          // // 关闭定时器
          this.getLotteryInfo();
          this.timer = null;
          this.count = 15;
        } else {
          this.count--;
        }
      }, 1000);
    },
    scrollToTop(e) {
      // console.log('scrollToTop', e);
      this.ifshow = e.target.scrollTop + e.target.clientHeight < e.target.scrollHeight;
      // let toTop = this.$refs.resListRef?.scrollTop;
      // if (toTop > 0) {
      //   this.ifshow = false;
      // } else {
      //   this.ifshow = true;
      // }
      // if (e.target.className === 'result-list') {
      //   const roundId = e.target.dataset.round;
      //   const index = this.lotteryInfo.rounds.findIndex((item) => {
      //     return item.id === roundId;
      //   });
      //   this.$set(this.lotteryInfo.rounds[index], 'hasMore', e.target.scrollTop + e.target.clientHeight < e.target.scrollHeight);
      //   console.log(index, this.lotteryInfo.rounds[index].hasMore);
      // }
    }
  },
  destroyed() {
    console.log('destroyed suswindow');
    this.$refs.piao && (this.$refs.piao.result = []);
    clearInterval(this.timer);
    clearInterval(this.timers);
    clearInterval(this.roomSignTimer);
    window.removeEventListener('scroll', this.scrollToTop, true);
  }
};
</script>
<style lang="less">
.sus-window {
  position: absolute;
  padding: 0 12px;
  bottom: 80px;
  right: 0;
  z-index: 99;
  .col_btn {
    user-select: none;
  }
  > div:not(.invite) {
    margin-bottom: 12px;
    // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      // box-shadow: 0 2px 5px rgb(0 0 0 / 10%);
    }
  }
  .link-but {
    img {
      width: 100%;
    }
  }

  .fticon {
    .iconfont {
      font-size: 28px;
      color: #fff;
    }
  }

  .share-icon {
    background: linear-gradient(135deg, rgba(254, 182, 54, 1) 0%, rgba(242, 142, 5, 1) 100%);
  }

  .give-like-icon {
    position: relative;
    background: linear-gradient(135deg, rgba(17, 110, 184, 1) 0%, rgba(1, 65, 118, 1) 100%);
  }

  .give-like {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 99;
  }

  .badge {
    position: absolute;
    display: inline-block;
    padding: 4px 6px;
    border-radius: 12px;
    border-bottom-right-radius: 0;
    background: #f34444;
    border: 1px solid #fff;
    color: #fff;
    right: 36px;
    top: -6px;
    font-size: 12px;
  }

  .lottery-info-tab {
    font-size: 18px;
    // background-color: #fff;
    padding: 12px 20px;
    min-height: 375px;
    display: flex;
    flex-direction: column;

    > div {
      min-height: 32px;
      display: flex;
      align-items: center;
      margin-bottom: 4px;
    }

    .title {
      font-size: 20px;
      justify-content: center;
      margin-bottom: 12px;
      font-weight: 500;
    }

    .desc {
      color: rgba(0, 0, 0, 0.5);
      margin-bottom: 12px;
      white-space: break-spaces;
      word-break: break-all;
    }

    .button {
      justify-content: center;
      padding: 20px 20px;
      width: 100%;

      .btn {
        border-radius: 28px;
        width: 100%;
        background: var(--primary);
        border-color: var(--primary);
        font-size: 20px;
        letter-spacing: 2px;
      }

      margin-top: auto;
    }
  }

  .lottery-result-tab {
    // background: #fff;
    padding: 12px 20px;
    padding-left: 20px;
    > div {
      min-height: 351px;
      max-height: 351px;
      overflow-y: auto;
    }
    .lottery_col {
      height: 42px;
      display: flex;
      align-items: center;
      font-size: 18px;
      justify-content: space-between;

      .phone {
        margin-right: 30px;
      }
    }
  }

  .tabs-panel {
    .van-tabs--line {
      .van-tab {
        font-size: 14px;
        font-weight: 400;
        color: #202224;
        margin: 16px 0;
        line-height: 20px;
        // font-family: PingFangSC-Regular, PingFang SC;
      }

      .van-tab--active {
        span {
          color: #0094f7;
          font-size: 18px;
          font-weight: 600;
        }
      }

      .van-tabs__line {
        background-color: var(--primary);
        width: 30px;
        height: 2px;
      }

      .van-tab__pane {
        margin-top: 0px;
      }

      .van-tabs--line .van-tabs__wrap {
        height: 52px;
      }

      [class*='van-hairline']::after {
        top: -55% !important;
        left: -50% !important;
        bottom: -50% !important;
      }
    }
  }

  .jinganbanner {
    background: none;
    padding-bottom: 0px;

    .tabs-panels {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      background-size: 100% 100%;
      background-repeat: no-repeat;

      &.tabs-img {
        .van-tabs {
          .van-tabs__wrap {
            .van-tabs__nav {
              width: 134px;
              height: 56px;
              left: 50%;
              margin-left: -67px;

              .van-tab {
                background-size: 100% 100%;
              }

              .van-tabs__line {
                width: 0;
              }
            }
          }
        }
      }
    }

    .van-tabs {
      .van-tabs__wrap {
        height: 75px;

        .van-tabs__nav--line {
          background: none;
          padding-top: 11px;

          .van-tab {
            background-repeat: no-repeat;
            background-size: 60% 60%;
            background-position-x: center;
            background-position-y: center;

            span {
              font-size: 15px;
              font-weight: 500;
              color: #cfe4f7;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            &.van-tab--active {
              background-size: 80% 80%;

              span {
                font-size: 18px;
                font-weight: 500;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }

      .van-tabs__content {
        .van-tab__pane {
          min-height: 470px;
          max-height: 470px;
          background: none;
          padding: 25px 12px;

          .wap {
            width: 100%;
            min-height: 175px;
            max-height: 175px;
            overflow-y: auto;
            border: 1px solid #d0e4f7;
            border-radius: 10px;
            padding: 20px 25px;
            margin-bottom: 20px;

            .title {
              font-size: 20px;
              font-weight: bold;
              color: #ffd149;
              text-align: center;
              margin-bottom: 15px;
            }

            .desc {
              color: rgba(0, 0, 0, 0.5);
              white-space: break-spaces;
              word-break: break-all;
              font-size: 17px;
              font-weight: 400;
              color: #feffff;
            }
          }

          .row {
            font-size: 17px;
            color: #feffff;
            padding-left: 23px;
            position: relative;
            line-height: 17px;
            display: flex;
            align-items: center;

            &.little_title {
              font-weight: bold;
              margin-bottom: 16px;
            }

            &.little_title::before {
              content: '';
              width: 3px;
              height: 12px;
              border-radius: 2px;
              margin-top: 0px;
              position: absolute;
              left: 9px;
              background: url(~@/assets/images/roundName_icon.png) center center / 100% 100% no-repeat;
            }
          }

          .row_border {
            width: 100%;
            border: 1px solid #ffffff;
            border-radius: 10px;
            padding: 5px 25px;
            font-size: 17px;
            font-weight: bold;
            color: #feffff;
            line-height: 28px;
            margin-top: 20px;

            .row_wap {
              font-weight: 400;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .row_correct {
                display: flex;
                justify-content: space-between;
                align-items: center;

                span {
                  margin-left: 10px;

                  img {
                    width: 17px;
                    height: 17px;
                  }
                }
              }

              .row_error {
                color: #000;
                border-radius: 50%;
                background: #ffd149;
                text-align: center;
                line-height: 17px;
                padding: 0px 5px 2px;
              }
            }
          }

          .button {
            overflow: hidden;
            text-align: center;
            margin-top: 37px;

            .btn {
              width: 100%;
              border-radius: 23px;
              font-size: 20px;
              font-weight: 500;
              color: #694500;
              line-height: 28px;
              text-shadow: 0px 0px 0px rgba(255, 255, 255, 0.7);
              border: none;
              padding: 5% 0;
            }

            .btns {
              background: linear-gradient(90deg, #ffe391, #ffc005);
            }

            .black {
              background: linear-gradient(90deg, #dad7d7, rgb(128, 127, 127));
            }
          }
          .waps {
            -webkit-overflow-scrolling: touch;
            overflow-y: scroll;
            min-height: 391px;
            max-height: 391px;
            &.wapse {
              min-height: 440px;
              max-height: 440px;
            }
            .col {
              height: 56px;
              color: #fff;
              font-size: 16px;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 0 24px;

              &:before {
                content: '';
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 1px;
                background: #fff;
                opacity: 0.3;
              }

              &:last-child::before {
                height: 0;
              }
            }
          }
          .waps_bottom {
            width: 100%;
            display: flex;
            bottom: 0;
            height: 56px;
            line-height: 56px;
            color: #fff;
            font-size: 16px;
            display: flex;
            justify-content: center;
          }
        }
      }
    }

    .van-tabs.lottery-result-tab-tabs {
      min-height: 30px;
      max-height: 30px;
      overflow: hidden;
      .van-tabs__wrap {
        height: 30px;
        .van-tabs__line {
          display: none;
        }
        .van-tabs__nav--line {
          padding: 0;
          height: 30px;
        }
        .van-tabs__nav {
          line-height: 30px;
          padding: 0;
          .van-tab {
            height: 30px;
          }
        }
      }
      &.lottery-result-tab-tabs-hidden {
        display: none;
      }
    }

    .lottery-result-tab-list {
      min-height: 400px;
      max-height: 400px;
      overflow: hidden;
      .result-list {
        height: 300px;
        max-height: 300px;
        overflow: scroll;
        .col {
          height: 56px;
          color: #fff;
          font-size: 16px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 24px;

          &:before {
            content: '';
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 1px;
            background: #fff;
            opacity: 0.3;
          }

          &:last-child::before {
            height: 0;
          }
        }
      }
      .waps_bottom {
        height: 40px !important;
        line-height: 40px !important;
      }
      .button {
        margin-top: 0 !important;
      }
      &.no-tabs {
        min-height: 430px;
        max-height: 430px;
        .result-list {
          height: 330px;
          max-height: 330px;
        }
      }
    }
  }
  .ja-win-form-popup {
    .win-form-title {
      font-weight: 600;
      font-size: 16px;
      color: #2a2b2c;
      line-height: 26px;
      padding: 18px 0;
      text-align: center;
      position: relative;
      .close-icon {
        padding: 8px;
        position: absolute;
        right: 16px;
        top: 16px;
        font-size: 16px;
        color: #989da3;
      }
    }
    .win-form-sub-title {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      padding: 0 28px;
      margin-bottom: 8px;
    }
    .van-field__label {
      width: 28px;
      font-weight: 400;
      font-size: 14px;
      color: #989da3;
    }
    .van-cell {
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .submit-btn {
      width: 250px;
      height: 44px;
      background: linear-gradient(270deg, #ff8963 0%, #fe4964 100%);
      border-radius: 33px;
      color: #fff;
      line-height: 44px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;
      margin-top: 28px;
      margin-bottom: 26px;
      margin-left: 18px;
      border: none;
    }
  }

  .jdbanner {
    background: none;
    padding-bottom: 0px;

    .tabs-panels {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      background-size: 100% 100%;
      background-repeat: no-repeat;

      &.tabs-img {
        .van-tabs {
          .van-tabs__wrap {
            .van-tabs__nav {
              width: 134px;
              height: 56px;
              left: 50%;
              margin-left: -67px;

              .van-tab {
                background-size: 100% 100%;
              }

              .van-tabs__line {
                width: 0;
              }
            }
          }
        }
      }
    }

    .van-tabs {
      .van-tabs__wrap {
        height: 75px;

        .van-tabs__nav--line {
          background: none;
          padding-top: 11px;

          .van-tab {
            background-repeat: no-repeat;
            background-size: 60% 60%;
            background-position-x: center;
            background-position-y: center;

            span {
              font-size: 15px;
              font-weight: 500;
              color: #cfe4f7;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            &.van-tab--active {
              background-size: 80% 80%;

              span {
                font-size: 18px;
                font-weight: 500;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }

      .van-tabs__content {
        .van-tab__pane {
          min-height: 470px;
          max-height: 470px;
          background: none;
          padding: 25px 12px;

          .wap {
            width: 100%;
            min-height: 175px;
            max-height: 175px;
            overflow-y: auto;
            border: 1px solid #d0e4f7;
            border-radius: 10px;
            padding: 20px 25px;
            margin-bottom: 20px;

            .title {
              font-size: 20px;
              font-weight: bold;
              color: #ffd149;
              text-align: center;
              margin-bottom: 15px;
            }

            .desc {
              color: rgba(0, 0, 0, 0.5);
              white-space: break-spaces;
              word-break: break-all;
              font-size: 17px;
              font-weight: 400;
              color: #feffff;
            }
          }

          .row {
            font-size: 17px;
            color: #feffff;
            padding-left: 23px;
            position: relative;
            line-height: 17px;
            display: flex;
            align-items: center;

            &.little_title {
              font-weight: bold;
              margin-bottom: 16px;
            }

            &.little_title::before {
              content: '';
              width: 3px;
              height: 12px;
              border-radius: 2px;
              margin-top: 0px;
              position: absolute;
              left: 9px;
              background: url(~@/assets/images/roundName_icon.png) center center / 100% 100% no-repeat;
            }
          }

          .row_border {
            width: 100%;
            border: 1px solid #ffffff;
            border-radius: 10px;
            padding: 5px 25px;
            font-size: 17px;
            font-weight: bold;
            color: #feffff;
            line-height: 28px;
            margin-top: 20px;

            .row_wap {
              font-weight: 400;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .row_correct {
                display: flex;
                justify-content: space-between;
                align-items: center;

                span {
                  margin-left: 10px;

                  img {
                    width: 17px;
                    height: 17px;
                  }
                }
              }

              .row_error {
                color: #000;
                border-radius: 50%;
                background: #ffd149;
                text-align: center;
                line-height: 17px;
                padding: 0px 5px 2px;
              }
            }
          }

          .button {
            overflow: hidden;
            text-align: center;
            margin-top: 30px;

            .btn {
              width: 100%;
              border-radius: 23px;
              font-size: 20px;
              font-weight: 500;
              color: #694500;
              line-height: 28px;
              text-shadow: 0px 0px 0px rgba(255, 255, 255, 0.7);
              border: none;
              padding: 5% 0;
            }

            .btns {
              background: linear-gradient(90deg, #ffe391, #ffc005);
            }

            .black {
              background: linear-gradient(90deg, #dad7d7, rgb(128, 127, 127));
            }
          }
          .waps {
            -webkit-overflow-scrolling: touch;
            overflow-y: scroll;
            min-height: 391px;
            max-height: 391px;
            &.wapse {
              min-height: 440px;
              max-height: 440px;
            }
            .col {
              height: 56px;
              color: #fff;
              font-size: 16px;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin: 0 24px;

              &:before {
                content: '';
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 1px;
                background: #fff;
                opacity: 0.3;
              }

              &:last-child::before {
                height: 0;
              }
            }
          }
          .waps_bottom {
            width: 100%;
            display: flex;
            bottom: 0;
            height: 56px;
            line-height: 56px;
            color: #fff;
            font-size: 16px;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
  .jd-custom-3 {
    .jd-custom-3_wrap {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      min-height: 400px;
      background-image: url('~@/assets/images/jd-lottery/bg-top.png');
      background-repeat: no-repeat;
      background-size: 100% auto;
      .jd-custom-3_top-time {
        height: 36px;
        min-width: 177px;
        padding: 24px;
        background-image: url('~@/assets/images/jd-lottery/bg-time.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 14px;
        font-weight: 500;
        color: #804600;
        line-height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .jd-custom-3_top-title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        width: 100%;
        .top-title_left,
        .top-title_right {
          width: 30%;
          max-width: 74px;
        }
        .top-title_text {
          margin: 0 16px;
          font-size: 20px;
          font-weight: 600;
          color: #58330e;
          line-height: 23px;
        }
      }
      .jd-custom-3_prize {
        width: 116px;
        height: 116px;
        &:not(:empty) {
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #f5f0df;
        }
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 32px;
        img {
          width: 100%;
          object-fit: contain;
        }
      }
      .jd-custom-3_token {
        font-size: 12px;
        font-weight: 400;
        color: #804600;
        line-height: 14px;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 20px;
      }
      .jd-custom-3_btn {
        height: 44px;
        background: linear-gradient(289deg, #ee3b61 0%, #fdd66a 100%);
        border-radius: 10px 10px 10px 10px;
        margin: 0 25px;
        width: calc(100% - 32px);
        color: #fff;
        text-align: center;
        line-height: 44px;
        max-width: 340px;
        font-size: 14px;
        letter-spacing: 1px;
        &.disabled {
          background: transparent;
          border: 1px solid #f5eed6;
          color: #58330e;
        }
      }
      .jd-custom-3_tip {
        font-size: 10px;
        font-weight: 400;
        color: #804600;
        line-height: 12px;
        text-align: center;
        margin-top: 12px;
      }
      .jd-custom-3_close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 24px;
        height: 24px;
      }
      .jd-custom-3_luck-list {
        padding: 24px;
        height: 100%;
        width: 100%;
        max-height: 70vh;
        overflow-x: hidden;
        overflow-y: scroll;

        .luck-list_item {
          display: flex;
          color: #58330e;
          font-size: 14px;
          .luck-list_item-name {
            width: 50%;
            text-align: center;
          }
          .luck-list_item-phone {
            text-align: center;
            flex: 1;
          }
        }
      }
    }
  }
}

.prize_img {
  width: 200% !important;
  height: auto !important;
  transform: translate(-39%, -31%);
}
.prize_post {
  position: relative;
}
.badges {
  position: absolute;
  display: inline-block;
  padding: 4px 6px;
  border-radius: 12px;
  border-bottom-right-radius: 0;
  background: #ffc20b;
  border: 1px solid #fff;
  color: #fff;
  right: 46px;
  top: -6px;
  font-size: 12px;
}
.van-action-sheet {
  max-height: 100%;
  bottom: 0;
}
.close_icon {
  background: url(~@/assets/images/close_icon.png) center center / 100% 100% no-repeat;
  width: 30px;
  height: 30px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 9999;
}
</style>
